export const dpr = () => window.devicePixelRatio || 1;
